// extracted by mini-css-extract-plugin
module.exports = {"container":"Delivering_container__1EL1b"};